import { AfterViewInit, Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Policy } from '../../../../../shared/models/info/policy';
import { IfPolicySatisfiedDirective } from '../../../../directives/if-policy-satisfied.directive';
import { ImportIconComponent } from '../../../icons/import-icon/import-icon.component';
import { initFlowbite } from 'flowbite';
import { CloseIconComponent } from '../../../icons/close-icon/close-icon.component';
import { NwNumber } from '../../../../../shared/models/nw-number/nw-number';
import { ImportType } from '../../../lists/nw-number/nw-number-accordion/import-type';
import { AgentActionDirective } from '../../../../directives/agent-action.directive';

@Component({
  selector: 'app-import-nw-number-popover',
  imports: [IfPolicySatisfiedDirective, ImportIconComponent, CloseIconComponent, AgentActionDirective],
  templateUrl: './import-nw-number-popover.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './import-nw-number-popover.scss',
})
export class ImportNwNumberPopover implements AfterViewInit {
  @Input() public nwNumber?: NwNumber;
  @Output() public importClicked = new EventEmitter<{ nwNumber: NwNumber; importType: ImportType }>();

  protected readonly popoverTargetId = `import-nw-number-popover-${crypto.randomUUID()}`;
  protected readonly policy = Policy;
  protected readonly importType = ImportType;
  protected isOpen = false;

  public ngAfterViewInit(): void {
    initFlowbite();
  }
}
